import { render, staticRenderFns } from "./AccountsListPage.vue?vue&type=template&id=07612cf1"
import script from "./AccountsListPage.vue?vue&type=script&lang=js"
export * from "./AccountsListPage.vue?vue&type=script&lang=js"
import style0 from "./AccountsListPage.vue?vue&type=style&index=0&id=07612cf1&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports